import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { api, constants, dateHelpers } from '../utils';
import { POAddContainerModal, POAddCostModal } from './';
import { toast } from "react-toastify";

export default function PODropdownMenu(props) {
   const [open, setOpen] = useState(false);
   const [showModal, setShowModal] = useState(false);
   const [showCostModal, setShowCostModal] = useState(false);

   function printPo() {
      // setWorking(true);
      api
         .postDownloadBinary(`Report/PODetailReport/${props.poNumber}`,
            {},
            constants.MIME_TYPES.pdf,
            `PO_${props.poNumber}_${dateHelpers.toLongDateString(Date.now())}_Report.pdf`,
            `Failed to download the Po Report, Po Number ${props.poNumber}`)
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch(api.catchHandler);
   }

   return (
      <td
         className="data-cell"
         onMouseEnter={() => setOpen(true)}
         onMouseLeave={() => setOpen(false)}
         style={{ position: "relative", verticalAlign: props.alignTop ? 'top' : 'middle' }}
      >
         <span className="shredLink fw-bold">{props.poNumber}</span>
         <Dropdown
            isOpen={open}
            toggle={() => setOpen(!open)}
            style={{ position: "absolute", top: "1.75em", left: "2em" }}
         >
            <DropdownMenu>
               <DropdownItem className='cursor-pointer' onClick={printPo}>
                  Print PO
               </DropdownItem>
               {props.showAddContainer &&
                  <DropdownItem
                     className='cursor-pointer'
                     onClick={() => setShowModal(true)}
                  >
                     Add Container
                  </DropdownItem>
               }
               {props.showAddCost &&
                  <DropdownItem
                     className='cursor-pointer'
                     onClick={() => setShowCostModal(true)}
                  >
                     Add Landed Cost
                  </DropdownItem>
               }
               <DropdownItem className="sort-handle">
                  <a href={`/attachments/${constants.ATTACHMENT_TYPES.PurchaseOrder}/${props.poNumber}`} className="regularAnchor" rel="noreferrer" target="_blank">Attachments {props.attachmentCount > -1 ? `(${props.attachmentCount})` : null}</a>
               </DropdownItem>
            </DropdownMenu>
         </Dropdown>
         {showModal &&
            <POAddContainerModal
               poNumber={props.poNumber}
               itemNumber={props.itemNumber}
               containers={props.containers}
               toggleCallback={() => setShowModal(false)}
               callbackRefresh={() => {
                  setShowModal(false);
                  props.callbackRefresh();
               }}
            />
         }
         {showCostModal &&
            <POAddCostModal
               poNumber={props.poNumber}
               toggleCallback={() => setShowCostModal(false)}
               callbackRefresh={() => {
                  setShowCostModal(false);
                  props.callbackRefresh();
               }}
            />
         }
      </td >
   );
}